export const hasEnumFlag = (flags, flag) => (flags & flag) === flag;
